import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './WhyAgentecfusion.css';

const WhyAgentecfusion = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <section id="capabilities" className="why-agentecfusion" ref={ref}>
      <div className="why-container">
        <motion.div
          className="why-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">{t.why.title}</h2>
          <p className="section-subtitle">
            {t.why.subtitle}
          </p>
        </motion.div>

        <div className="features-grid">
          {t.why.features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h3 className="feature-title">{feature.title}</h3>
              <ul className="feature-points">
                {feature.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAgentecfusion;
